import * as tslib_1 from "tslib";
import { EnvService } from './env.service';
import { UserService } from './services/user.service';
import * as i0 from "@angular/core";
import * as i1 from "./services/user.service";
import * as i2 from "./env.service";
export class WeavyChatService {
    constructor(userService, envService) {
        this.userService = userService;
        this.envService = envService;
    }
    init() {
        this.weavy = new Weavy({ init: true, url: this.envService.WEAVY_URL, tokenFactory: () => this.getAccessToken(), tz: this.getTimezone() });
    }
    openChat(uid) {
        this.init();
        let wyChat = new WeavyLib.WyChat();
        wyChat.uid = uid;
        wyChat.features = { "attachments": false };
        return wyChat;
    }
    getAllConversations() {
        this.init();
        return this.weavy.get('/api/conversations');
    }
    getConversationById(roomId) {
        this.init();
        return this.weavy.get('/api/conversations/' + roomId);
    }
    syncUserName(username, image, uid) {
        this.init();
        return this.weavy.post('/api/users/' + uid, "PUT", JSON.stringify({ name: username, picture: image }));
    }
    getAccessToken() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                this.userService.getWeavyAccessToken().subscribe((response) => {
                    if (response['status'] && response['result'] && response['result']['access_token']) {
                        resolve(response['result']['access_token']);
                    }
                    else {
                        resolve('');
                    }
                }, (error) => {
                    reject('');
                });
            });
        });
    }
    getTimezone() {
        let timezone = Intl.DateTimeFormat('en', { timeZoneName: 'long' }).formatToParts(new Date())
            .find(part => part.type === 'timeZoneName')
            .value;
        return timezone;
    }
}
WeavyChatService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WeavyChatService_Factory() { return new WeavyChatService(i0.ɵɵinject(i1.UserService), i0.ɵɵinject(i2.EnvService)); }, token: WeavyChatService, providedIn: "root" });
